import { Form } from "antd";
import Username from "@Assets/icons/username.svg";
import { CustomButton } from "@Components/Button";
import { useNavigate } from "react-router-dom";
import FormItem from "@Components/FormItem/FormItem";
import ArrowRight from "@Assets/icons/arrow-right.svg";
import UnAuthHeader from "../UnAuthHeader";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import useForgotPasswordContainer from "./useContainerForgotPassword";

const ForgotPassword = () => {
  const { form, isPending, handleSubmit, handleLogin, navigate } =
    useForgotPasswordContainer();

  return (
    <div className="flex justify-center items-center w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
      <div className="py-4 sm:py-6 px-6 bg-white w-full max-w-[360px] sm:max-w-[400px] 2xl:max-w-[448px] min-h-[350px] 2xl:min-h-[420px] rounded-[18px] shadow-md  ">
        <UnAuthHeader
          headerTitle="Email"
          subTitle="Provide your email on which we can send an auto generated password for you to login"
        />

        <div className="px-2 !mb-4 pt-2 ">
          <Form
            initialValues={{ remember: true }}
            onFinish={handleSubmit}
            className="py-2"
          >
            <FormItem
              name="email"
              label={"Email Address"}
              inputConfig={{
                label: "Email",
                type: "email",
                placeholder: "Email",
                leftIcon: <Username />,
              }}
              rules={[
                { required: true, message: "Please Enter your email" },
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              ]}
            />
            <Form.Item className="text-center max-w-full !pt-2">
              <CustomButton
                title={"Send"}
                shape="round"
                btnColor="danger"
                type="primary"
                iconPosition="right"
                icon={<ArrowRight />}
                className="w-full h-[44px] sm:h-[50px] font-bold tracking-[1%] !rounded-[12px] text-sm sm:text-base"
                htmlType="submit"
                isLoading={isPending}
                disabled={isPending}
              />
            </Form.Item>
            <div className="text-center">
              <p className="text-[#575757] text-[14px] sm:text-[14px] font-[500]">
                Back to{" "}
                <span
                  className="text-[#111827] font-[500] cursor-pointer"
                  onClick={() => navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)}
                >
                  Login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
